// storage.js
const storage = {
  getItem(key) {
    try {
      const value = localStorage.getItem(key);
      if (value === null) return null;
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    } catch {
      return null;
    }
  },

  setItem(key, value) {
    try {
      localStorage.setItem(
        key,
        typeof value === "string" ? value : JSON.stringify(value)
      );
    } catch (e) {
      console.error("Storage error", e);
    }
  },

  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Storage error", e);
    }
  },

  clear() {
    try {
      localStorage.clear();
    } catch (e) {
      console.error("Storage error", e);
    }
  },
};

export default storage;